
// packages
import React, { useEffect, useState } from 'react';
import { Box, Typography, Stack, Button, Modal } from '@mui/material'
import { useMediaQuery } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid'
import VisibilityIcon from '@mui/icons-material/Visibility';
import IconButton from '@mui/material/IconButton';

// local
import deleteExamDate from '../helpers/deleteExamDate';
import CalendarEventModal from './CalendarEventModal';
import reserveDate from '../helpers/reserveDate';
import formatTime from '../utilities/fromatTime';
import formatExamDate from '../utilities/formatExamDate';
import ScheduledTestersModal from './ScheduledTestersModal';
import { getScheduledTesters } from '../helpers/requestScheduledTesters';
import { postScheduledTesters } from '../helpers/requestScheduledTesters';
import { getNeedsRetake } from '../helpers/getNeedsRetake';
import ConfirmActionModal from './ConfirmActionModal';
import CardTable from '../widgets/CardTable';
import { useNavigate } from 'react-router-dom';

const DateInformationModal = ({date, examDateInfo, handleClose, userData, refreshHook=null, setAlert=null, onRowClick=null}) => {
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // DEFINITIONS
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    const isMobile = useMediaQuery("(max-width:600px)");
    const examDateObj = examDateInfo[0];
    const reserverObj = examDateInfo[1];
    const timeSlotsArr = examDateInfo[2];
    const navigate = useNavigate();

    const paginationModel = { page: 0, pageSize: 5 };
    const gridRows = timeSlotsArr;
    const gridColumns = [
        { headerName: 'ID', field: 'id'},
        { flex:1, headerName: 'Start', field: 'start_time', editable: userData.userType==='district_admin'?true:false, renderCell: (params) => <span>{formatTime(params.row.start_time)}</span>},
        { flex:1, headerName: 'End', field: 'end_time', editable: userData.userType==='district_admin'?true:false, renderCell: (params) => <span>{formatTime(params.row.end_time)}</span>},
        { flex:1, headerName: 'Max', field: 'max_participants', editable: userData.userType==='district_admin'?true:false},
        {
            field: 'view',
            headerName: '',
            flex: userData.userType==='district_admin'?null:1.05,
            width:userData.userType==='district_admin'?60:null,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => (
                userData.userType==='district_admin' ? (
                    <IconButton
                        onClick={(e) => {
                            e.stopPropagation();
                            handleTimeslotRowClick(params)
                        }}
                        aria-label="view answers"
                    >
                        <VisibilityIcon />
                    </IconButton>
                ) : (
                    <Button 
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate(`/reservation-pipeline/${params.row.id}`);
                            //handleTimeSlotRowClickTester(params);
                        }}
                        aria-label="reserve time slot"
                        variant='contained'
                        sx={{width:'100%'}}
                    >
                        Reserve
                    </Button>
                )
            )
        }
      ];

    const [timeslotSelected, setTimeslotSelected] = useState(null);
    const [timeSlotId, setTimeSlotId] = useState(null);
    const [openScheduledTesters, setOpenScheduledTesters] = useState(false);
    const toggleOpenScheduledTesters = () => setOpenScheduledTesters(!openScheduledTesters);

    const [openCalendarEvent, setOpenCalendarEvent] = useState(false);
    const handleOpenCalendarEvent = () => setOpenCalendarEvent(true);
    const handleCloseCalendarEvent = () => setOpenCalendarEvent(false);

    const [rowUpdates, setRowUpdates] = useState({});

    const [scheduledTesters, setScheduledTesters] = useState(null);

    const [singleUserRetake, setSingleUserRetake] = useState(null);

    const [canClose, setCanClose] = useState(false);
    useEffect(() => {
        if (canClose) {
            handleClose();
            setCanClose(false);
        }
    }, [canClose, handleClose]);

    useEffect(() => {
        if (singleUserRetake) {    
            if (singleUserRetake.length === 0) {
                postScheduledTesters(timeSlotId, userData.userId, 'language, math, reading', setAlert);
            } else {
                postScheduledTesters(timeSlotId,userData.userId,singleUserRetake[0].retake, setAlert)
            }   
            
        }
    }, [singleUserRetake, setAlert, timeSlotId, userData.userId]);
    


    const handleSaveChanges = async () => {
        const updates = Object.values(rowUpdates);
        try {
            for (const update of updates) {
                reserveDate(date, update.start_time, update.end_time, update.max_participants);
            }
            setRowUpdates({});
            alert('Changes saved!');
        } catch (error) {
            console.error(error);
            alert('Failed to save changes.');
        }
    };

    const handleTimeslotRowClick = (params) => {
        let timeslotId = params.row.id;
        setTimeSlotId(params.row.id);
        setTimeslotSelected(formatTime(params.row.start_time) + " - " + formatTime(params.row.end_time));

        getScheduledTesters(timeslotId, (data) => {
            setScheduledTesters(data)
            if (data !== null) {
                toggleOpenScheduledTesters();
            }
        });
    };

    const handleTimeSlotRowClickTester = (params) => {
        let timeSlotId = params.row.id;
        setTimeSlotId(timeSlotId);
        setTimeslotSelected(formatTime(params.row.start_time) + " - " + formatTime(params.row.end_time));

        getNeedsRetake(setSingleUserRetake, setCanClose);
    };

    const [openConfirmAction, setOpenConfirmAction] = useState(false);
    const toggleOpenConfirmAction = () => setOpenConfirmAction(!openConfirmAction);
    const [canProceed, setCanPoceed] = useState(false);
    useEffect(() => {
        if (canProceed) {
            deleteExamDate(examDateObj['id'], refreshHook)
            handleClose();
            setCanPoceed(false);
        };
    },[canProceed, setCanPoceed, examDateObj, refreshHook, handleClose]);

    
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // STYLES 
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: '95vw',
        minWidth:'75vw',
        maxHeight: '95vh',
        overflowY: 'auto',
        bgcolor: 'background.paper',
        borderRadius: 4,
        boxShadow: 24,
        p: 4,
    }
    const mobileModalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '95vw',
        bgcolor: 'background.paper',
        borderRadius: 4,
        boxShadow: 24,
        p: 2,
        height: '90vh',
        overflowY:'hidden',
        display:'flex',
        flexDirection:'column'
    }

    const gridStyle = {m:1, mb:3, borderRadius:4, cursor:'pointer',}

    return (
        <>
            <Modal
                open={openScheduledTesters}
                onClose={toggleOpenScheduledTesters}
            >
               <ScheduledTestersModal
                    scheduled_testers={scheduledTesters}
                    time_slot={timeslotSelected}
                    time_slot_id={timeSlotId}
                    handleClose={toggleOpenScheduledTesters}
                    extraClose={handleClose}
                    onRowClick={onRowClick}
               />
            </Modal>
            <Modal
                open={openCalendarEvent}
                onClose={handleCloseCalendarEvent}
            >
                <CalendarEventModal
                    date={date}
                    handleClose={handleCloseCalendarEvent}
                    extraClose={handleClose}
                    refreshHook={refreshHook}
                />
            </Modal>
            <Modal
                open={openConfirmAction}
                onClose={toggleOpenConfirmAction}
            >
                <ConfirmActionModal
                    actionString={'delete this exam date'}
                    handleClose={toggleOpenConfirmAction}
                    confirmationHook={setCanPoceed}
                    extraClose={handleClose}
                />
            </Modal>
            <Box sx={!isMobile ? (modalStyle) : (mobileModalStyle)}>
                <Box>
                    <Stack direction={"row"} sx={{justifyContent:'space-between'}}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" sx={{fontWeight:600}}>
                            Exam Time Slots for <Typography variant='h5' sx={{ fontWeight:600, color:'#1483FA', display:'inline-block'}}>{formatExamDate(examDateObj['date'])}</Typography>
                        </Typography>
                        {userData.userType === 'district_admin' && (
                            <Button 
                                variant='outlined' 
                                sx={{
                                    "&:hover": { backgroundColor: "#c44601", color:"#FFFFFF", borderColor:"#FFFFFF"}
                                }}
                                onClick={() => {
                                    toggleOpenConfirmAction();
                                }}
                            >
                                Delete Exam Date
                            </Button>
                        )}
                    </Stack>
                    <Typography id="modal-modal-description" sx={{ mt: 2, mb:2 }}>
                        Reserved By {reserverObj['first_name'] + ' ' + reserverObj['last_name']}
                    </Typography>
                </Box>
                {!isMobile ? (
                    <DataGrid
                        sx={gridStyle}
                        rows={gridRows}
                        columns={gridColumns}
                        initialState={{ 
                            pagination: { paginationModel },
                            columns: {
                                columnVisibilityModel: {
                                    id: false,
                                    max_participants: userData.userType === 'district_admin' ? true : false,
                                }
                            },
                            sorting: {
                                sortModel: [
                                { field: 'start_time', sort: 'asc' },
                                ]
                            },
                        }}
                        disableRowSelectionOnClick
                        processRowUpdate={(newRow) => {
                            setRowUpdates(prev => ({
                                ...prev,
                                [newRow.id]: newRow,
                            }));
                            return newRow;
                        }}
                    />
                ):
                (
                    <CardTable
                        rows={gridRows}
                        columns={gridColumns}
                        sort={{key:'start_time', direction:'asc'}}
                        columnVisibilityModel={{
                            id: false,
                            max_participants: userData.userType === 'district_admin' ? true : false,
                        }}
                        sx={{height:'70%', overflowY: 'scroll'}}
                    />
                )}
                
                <Stack 
                    direction={'row'} 
                    sx={
                        isMobile ? {pb:1, justifyContent:'space-between', position:'fixed', bottom:0, justifySelf:'center', width:'95%'}
                        : {p:0, justifyContent:'space-between'}
                    }
                >
                    <Button variant='outlined' onClick={() => handleClose()}>Cancel</Button>
                    {userData.userType === 'district_admin' && (
                        <>
                        <Stack direction={'row'} spacing={1}>
                            <Button variant='contained' sx ={{}} onClick={() => {
                                handleOpenCalendarEvent();
                            }}>
                                Add Time Slot +
                            </Button>
                            <Button
                                variant='contained'
                                color='success'
                                onClick={handleSaveChanges}
                                disabled={Object.keys(rowUpdates).length === 0}
                            >
                                Save Changes
                            </Button>
                        </Stack>
                        </>
                    )}
                </Stack>
            </Box>
        </>
    );
}

export default DateInformationModal;